import FileResultDto from 'modules/base/dto/file/FileResultDto';
import nBossConnection from '../nBossConnection';

export function getFileEntityKey(value) {
	const candidate = value && typeof value === 'object'
		? value.key ?? value.fileKey
		: value;

	if (typeof candidate === 'string' && candidate.trim()) return candidate;
	if (typeof candidate === 'number' && Number.isFinite(candidate)) return String(candidate);
	return null;
}

export function getFileEntityUploadKey(value) {
	let uploadResult = value;

	if (typeof uploadResult === 'string') {
		const trimmed = uploadResult.trim();
		if (!trimmed) return null;

		try {
			uploadResult = JSON.parse(trimmed);
		} catch (error) {
			return trimmed;
		}
	}

	if (uploadResult && typeof uploadResult === 'object' && uploadResult.successful === false) {
		return null;
	}

	const directKey = getFileEntityKey(uploadResult);
	if (directKey !== null) return directKey;
	if (!uploadResult || typeof uploadResult !== 'object') return null;

	return getFileEntityKey(uploadResult.value) ?? getFileEntityKey(uploadResult.data);
}

class FileEntityService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'fileEntityControl';
	}

	/**
	 * @param {string} key
	 * @return {Promise<FileResultDto>}
	 */
	getFile(key) {
		const fileKey = getFileEntityKey(key);
		if (fileKey === null) return Promise.reject(new TypeError('A file key is required.'));

		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getFile`, {
					key: fileKey
				})
				.then(response => resolve(new FileResultDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} key
	 * @return {Promise<FileResultDto>}
	 */
	getInfo(key) {
		const fileKey = getFileEntityKey(key);
		if (fileKey === null) return Promise.reject(new TypeError('A file key is required.'));

		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInfo`, {
					key: fileKey
				})
				.then(response => resolve(new FileResultDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {Array<string>} keys
	 * @return {Promise<Array.<FileResultDto>>}
	 */
	getInfos(keys) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInfos`, {
					keys
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new FileEntityService();
